// extracted by mini-css-extract-plugin
export default {"item":"Item_item__xLep1","avatar":"Item_avatar__h6fnr","man":"Item_man__N6Yf+","position":"Item_position__qRkI2"};